<template>
  <el-dialog
    title="推广记录"
    :visible.sync="isVisitle"
    width="80%"
  >
    <el-form label-width="100px">
      <el-form-item label="渠道名称：">
        <el-input :disabled="true" v-model="mixedData.ch_path" class="jm-input280"></el-input>
      </el-form-item>
    </el-form>
    <jm-tableList
      v-if="isVisitle"
      :url="url"
      :refresh.sync="exporting"
      row-key="id"
      :search-data="searchData"
      :page-sizes="[4, 8, 10, 20]"
      :page-size="4"
      class="adminList"
    >
      <el-table-column slot="firstColumn" width="50" label="序号" type="index"></el-table-column>
      <el-table-column
        fixed="right"
        slot="lastColumn"
        label="操作"
        class-name="scope-button-list"
        width="170px"
      >
        <template slot-scope="scope">
          <el-row>
            <el-button size="mini" type="primary" @click="alertQrcode(scope.row)">二维码</el-button>
            <el-button size="mini" type="danger" :disabled="isDeleting" @click="handleDelete(scope.row)">删除</el-button>
          </el-row>
        </template>
      </el-table-column>
    </jm-tableList>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">返 回</el-button>
    </span>
    <el-dialog
      v-if="isQrcodeVisitle"
      title="推广二维码"
      :visible.sync="isQrcodeVisitle"
      :append-to-body="true"
      width="400px"
    >
      <div style="text-align:center;">
        <img style="display:inline-block;" :src="currentRow.qr_url" ref="qrImage" />
      </div>
      <div style="text-align:center;">
        <el-button size="mini" type="primary" :download="currentRow.act_title" @click="downloadQrcode">下载</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import JmTableList from '@/components/data/tableList';

export default {
  name: 'HistoryDialog',
  components: { JmTableList },
  props: {
    visible: {
      type: [Boolean],
      default: false
    },
    onCancle: {
      type: [Function, null],
      default: null
    },
    initialValue: {
      type: [Object],
      default() { return {}; }
    },
    onDeleted: {
      type: [Function, null],
      default: null
    }
  },
  data () {
    return {
      mixedData: this.initialValue,
      searchData: {
        ch_id: this.initialValue.ch_id
      },
      exporting: false,
      url: '/training/channel/promotionsByChannel',
      isQrcodeVisitle: false,
      currentRow: {},
      isDeleting: false
    };
  },
  methods: {
    handleCancel () {
      this.onCancle && this.onCancle();
    },
    handleDelete (row) {
      this.$confirm('确定要删此推广链接？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isDeleting = true;
        this.$http._post({
          url: '/training/channel/promotionDelete',
          data: { id: row.id }
        }).then(() => {
          this.exporting = true;
          this.onDeleted && this.onDeleted();
          this.isDeleting = false;
        });
      });
    },
    downloadQrcode() {
      const a = document.createElement('a');
      a.download = this.currentRow.act_title;
      a.href = this.$refs.qrImage.src;
      a.click();
    },
    alertQrcode(row) {
      this.isQrcodeVisitle = true;
      this.currentRow = { ...row };
    }
  },
  computed: {
    isVisitle: {
      get() {
        if (this.visible) {
          this.searchData.ch_id = this.mixedData.ch_id;
          this.exporting = true;
        }
        return this.visible;
      },
      set() {
        this.onCancle && this.onCancle();
      }
    }
  },
  watch: {
    initialValue: {
      handler (newValue) {
        this.mixedData = newValue;
      },
      deep: true
    }
  }
};
</script>
